import { Component } from "react"

export const WINNER = 'WINNER'
export const DRAW   = 'DRAW'
export const LOSER  = 'LOSER'

export const KEYSRESULT = {
    [WINNER]: 'eventodeportivo_paises_fichasuperior_texto_ganado',
    [DRAW]: 'eventodeportivo_paises_fichasuperior_texto_empate',
    [LOSER]: 'eventodeportivo_paises_fichasuperior_texto_perdido'
}

export const tabsSecondLevelCountryDetails = [
  { id: 'stats', label: 'eventodeportivo_paises_tabs2_texto_tab1', maxCharacteres: 19},
  { id: 'squad', label: 'eventodeportivo_paises_tabs2_texto_tab2', maxCharacteres: 19 },
  { id: 'matches', label: 'eventodeportivo_paises_tabs2_texto_tab3', maxCharacteres: 19 },
  { id: 'standings', label: 'eventodeportivo_paises_tabs2_texto_tab4', maxCharacteres: 19 },
]


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/constants.js